<script setup lang="ts">
import { computed } from 'vue'
import { commandLink, commandText } from '@/botLinks'
import { useBotUsername } from '@/composables/useBotUsername'
import { openMarkdownLink } from '@/telegramWebApp'

// A bot command in running text. Opens the bot's chat with the command typed into the input; plain text while the
// bot's username is not known.
const props = defineProps<{ command: string; args?: boolean }>()
const botUsername = useBotUsername()
const href = computed(() => (botUsername.value ? commandLink(botUsername.value, props.command, { args: props.args }) : ''))

function open(event: MouseEvent) {
  event.preventDefault()
  openMarkdownLink(href.value)
}
</script>

<template>
  <a v-if="href" :href="href" class="command-link" @click="open">{{ commandText(command) }}</a>
  <code v-else>{{ commandText(command) }}</code>
</template>
